import type { RouteRecordRaw } from 'vue-router'

const efficiencyRoutes: RouteRecordRaw[] = [
  {
    path: 'efficiency',
    name: 'efficiency',
    component: () => import('@/views/efficiency/EfficiencyOverview.vue'),
    meta: { title: '人效助手', permission: ['efficiency:view', 'requirement:view'] }
  },
  {
    path: 'efficiency/requirement-time',
    name: 'efficiency-requirement-time',
    component: () => import('@/views/efficiency/EfficiencyTimeAnalysis.vue'),
    meta: { title: '上线时间分析', permission: ['efficiency:view', 'requirement:view'] }
  },
  {
    path: 'efficiency/story-point-time',
    name: 'efficiency-story-point-time',
    component: () => import('@/views/efficiency/EfficiencyStoryPointAnalysis.vue'),
    meta: { title: '单位故事点时间分析', permission: ['efficiency:view', 'requirement:view'] }
  },
  {
    path: 'efficiency/rankings',
    name: 'efficiency-rankings',
    component: () => import('@/views/efficiency/EfficiencyRanking.vue'),
    meta: { title: '赛道人效排名', permission: ['efficiency:ranking:view', 'requirement:view'] }
  }
]

export default efficiencyRoutes
